import $ from 'jquery';
import './jquery-global';
import './vendor/jquery.input-phone-mask';
import './vendor/jquery.form-validation';
import 'textarea-autosize';

import initSocials from './modules/socials';
import initPopup from './modules/popup';
import initFancybox from './modules/fancybox';
import initCommentForm from './modules/comment-form';
import initCallbackForm from './modules/callback-form';
import initCallbackPopup from './modules/callback-popup';
import initOnlineDiagnostic from './modules/online-diagnostic';

$(function() {
  initSocials();
  initPopup();
  initFancybox();

  initCommentForm();
  initCallbackForm();
  initCallbackPopup();
  initOnlineDiagnostic();
});